import { ViewColumn, ViewColumnTwoTone } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import { Popup } from "@grapecity/wijmo.react.input";
import { forwardRef, useCallback, useEffect, useRef, useState } from "react";

const EMPTY_FORCE_HIDDEN_COLS = [];

const getColumns = (grid) => {
  const columns = grid?.columns;

  if (!columns) return [];
  if (Array.isArray(columns)) return columns;
  if (typeof columns.map === "function") return columns.map((column) => column);
  if (typeof columns.length === "number") {
    return Array.from({ length: columns.length }, (_, index) => columns[index]);
  }

  return [];
};

const SimpleColumnPicker = forwardRef((props, ref) => {
  const { forceHiddenCols = EMPTY_FORCE_HIDDEN_COLS, refreshKey } = props;
  const popupRef = useRef();
  const [columnItems, setColumnItems] = useState([]);

  const saveColumnPickerSettings = () => {};

  const popupInitialized = (popup) => {
    popup.isDraggable = true;
    popup.isResizable = false;
    popup.fadeOut = false;
    popup.fadeIn = false;

    popupRef.current = popup;
  };

  const readColumns = useCallback(
    () =>
      getColumns(ref?.current)
        .filter((column) => column?.binding)
        .filter((column) => !forceHiddenCols.includes(column.binding))
        .map((column) => ({
          binding: column.binding,
          header: column.header,
          visible: column.visible !== false,
        })),
    [forceHiddenCols, ref],
  );

  useEffect(() => {
    forceHiddenCols.forEach((binding) => {
      const column = ref?.current?.getColumn?.(binding);
      if (column) column.visible = false;
    });

    setColumnItems(readColumns());
  }, [forceHiddenCols, readColumns, ref, refreshKey]);

  const handleCheck = (event, item) => {
    const visible = event.target.checked;
    const column = ref?.current?.getColumn?.(item?.binding);

    if (column) {
      column.visible = visible;
      ref.current.invalidate?.();
    }

    setColumnItems((currentItems) =>
      currentItems.map((currentItem) =>
        currentItem.binding === item.binding
          ? { ...currentItem, visible }
          : currentItem,
      ),
    );
  };

  return (
    <>
      <Popup initialized={popupInitialized} lostFocus={saveColumnPickerSettings}>
        <Stack style={{ maxHeight: "96vh", overflowY: "auto" }}>
          <div className="wj-dialog-header Qub-DatagridBringValueView" style={{}}>
            <div>
              <div
                style={{
                  marginBottom: 0,
                  marginTop: 0,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <ViewColumn sx={{ marginRight: "6px" }} />
                <Typography sx={{ display: "inline" }} variant="body6">
                  Στήλες
                </Typography>
              </div>
            </div>
            <button
              type="button"
              style={{ cursor: "pointer" }}
              tabIndex={-1}
              className="close wj-hide"
            >
              &times;
            </button>
          </div>
          <Stack sx={{ padding: 2 }}>
            {columnItems.map((item) => (
              <FormControlLabel
                key={item.binding}
                control={
                  <Checkbox
                    style={{
                      width: "20px",
                      marginLeft: 19,
                      marginRight: 5,
                      padding: 0,
                    }}
                    name={item.binding}
                    checked={item.visible}
                    onChange={(event) => handleCheck(event, item)}
                  />
                }
                label={item.header?.toUpperCase()}
              />
            ))}
          </Stack>
        </Stack>
      </Popup>
      <Box boxShadow={2} sx={{ borderRadius: 50, width: "40px", height: "40px" }}>
        <IconButton
          disabled={columnItems.length === 0}
          onClick={() => popupRef.current?.show(true)}
        >
          <ViewColumnTwoTone />
        </IconButton>
      </Box>
    </>
  );
});

export default SimpleColumnPicker;
